import store from '../../../core/store';
import queryString from 'query-string';

export const listFiles = (stage_id) => {
  return store.dispatch({
    action: 'table.files/LIST_FILES',
    method: 'GET',
    endpoint: '/v2/stages/' + stage_id + '/files',
    main: true,
  });
};

export const readFile = (stage_id, attachment_id) => {
  return store.dispatch({
    action: 'table.files/READ_FILE',
    method: 'GET',
    endpoint: '/v2/stages/' + stage_id + '/files/' + attachment_id,
    has404: true,
  });
};

export const listFileFolders = (stage_id) => {
  return store.dispatch({
    action: 'table.files/LIST_FILE_FOLDERS',
    method: 'POST',
    endpoint: '/v2/stages/' + stage_id + '/files/folders',
  });
};

export const attachFilesToFolders = (stage_id, formData) => {
  return store.dispatch({
    action: 'table.files/ATTACH_FILES_TO_FOLDERS',
    method: 'POST',
    endpoint: '/v2/stages/' + stage_id + '/files/folders/attach',
    data: formData,
  });
};

export const uploadFiles = (stage_id, files) => {
  return store.dispatch({
    action: 'table.files/UPLOAD_FILES',
    method: 'POST',
    endpoint: '/v2/stages/' + stage_id + '/files',
    preloaded: false,
    data: {
      files,
    },
  });
};

export const browseFiles = (stage_id, params = {}) => {
  const query = queryString.stringify(params);

  return store.dispatch({
    action: 'table.files/BROWSE_FILES',
    method: 'GET',
    endpoint: '/v2/stages/' + stage_id + '/files' + (query ? '?' + query : ''),
    preloaded: false,
  });
};

export const listFileLinkTargets = (
  stage_id,
  model_type,
  attachment_id,
  params = {},
) => {
  const query = queryString.stringify({
    ...params,
    attachment_id,
  });

  return store.dispatch({
    action: 'table.files/LIST_FILE_LINK_TARGETS',
    method: 'GET',
    endpoint:
      '/v2/stages/' +
      stage_id +
      '/files/link-targets/' +
      model_type +
      (query ? '?' + query : ''),
    preloaded: false,
  });
};

export const linkFilesToModel = (stage_id, model_type, model_id, files) => {
  return store.dispatch({
    action: 'table.files/LINK_FILES_TO_MODEL',
    method: 'POST',
    endpoint: '/v2/stages/' + stage_id + '/files/link',
    data: {
      model_type,
      model_id,
      files: files.map((file) => {
        if (typeof file === 'object') {
          const data = {
            id: file.id || file.attachment_id,
          };

          if (file.category !== undefined && file.category !== null) {
            data.category = file.category;
          }

          return data;
        }

        return { id: file };
      }),
    },
  });
};

export const linkFilesToModules = (stage_id, attachment_ids, targets) => {
  return store.dispatch({
    action: 'table.files/LINK_FILES_TO_MODULES',
    method: 'POST',
    endpoint: '/v2/stages/' + stage_id + '/files/link',
    data: {
      files: attachment_ids.map((attachment_id) => ({ id: attachment_id })),
      targets: targets.map(({ model_type, model_id, category }) => ({
        model_type,
        model_id,
        category,
      })),
    },
  });
};

export const unlinkFileFromModule = (stage_id, attachment_id, link_id) => {
  return store.dispatch({
    action: 'table.files/UNLINK_FILE_FROM_MODULE',
    method: 'DELETE',
    endpoint:
      '/v2/stages/' +
      stage_id +
      '/files/' +
      attachment_id +
      '/links/' +
      link_id,
  });
};

export const updateFileTags = (stage_id, attachment_id, tags) => {
  return store.dispatch({
    action: 'table.files/UPDATE_FILE_TAGS',
    method: 'PUT',
    endpoint: '/v2/stages/' + stage_id + '/files/' + attachment_id + '/tags',
    data: {
      tags,
    },
  });
};

export const multipleEditFileTags = (stage_id, file_ids, tags) => {
  return store.dispatch({
    action: 'table.files/MULTIPLE_EDIT_FILE_TAGS',
    method: 'PUT',
    endpoint: '/v2/stages/' + stage_id + '/files/tags',
    data: {
      files: file_ids,
      tags,
    },
  });
};

export const downloadFiles = (stage_id, file_ids) => {
  return store.dispatch({
    action: 'table.files/DOWNLOAD_FILES',
    method: 'POST',
    endpoint: '/v2/stages/' + stage_id + '/files/download',
    data: {
      files: file_ids,
    },
  });
};

export const archiveFiles = (stage_id, file_ids) => {
  return store.dispatch({
    action: 'table.files/ARCHIVE_FILES',
    method: 'PUT',
    endpoint: '/v2/stages/' + stage_id + '/files/archive',
    data: {
      files: file_ids,
    },
  });
};

export const unarchiveFiles = (stage_id, file_ids) => {
  return store.dispatch({
    action: 'table.files/UNARCHIVE_FILES',
    method: 'PUT',
    endpoint: '/v2/stages/' + stage_id + '/files/unarchive',
    data: {
      files: file_ids,
    },
  });
};
